
import React, { useState } from 'react';
import { Lock, Loader, AlertCircle, CheckCircle } from 'lucide-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { API_BASE } from '../config';

export default function ResetPassword({ t }) {
  const [passwords, setPasswords] = useState({ newPassword: '', confirmPassword: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const validatePassword = (password) => {
    const regex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[\W_]).{12,}$/;
    return regex.test(password);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!token) return setError("Invalid Token.");
    if (passwords.newPassword !== passwords.confirmPassword) return setError(t.admin?.account?.errorMatch || "Error");
    if (!validatePassword(passwords.newPassword)) return setError(t.auth.passwordRequirements);

    setLoading(true);
    try {
      const response = await fetch(`${API_BASE}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword: passwords.newPassword })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Error');
      setSuccess(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) { setError(err.message); } finally { setLoading(false); }
  };

  if (success) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-50 via-white to-purple-50 px-4">
        <div className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-md text-center">
          <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-gray-800 mb-2">{t.auth.resetSuccess}</h2>
          <p className="text-gray-500">...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-50 via-white to-purple-50 px-4">
      <div className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-md border border-gray-100">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">{t.auth.resetTitle}</h2>
        {error && <div className="mb-4 p-3 bg-red-50 text-red-600 rounded-lg text-sm flex items-center"><AlertCircle className="h-4 w-4 mr-2 flex-shrink-0" />{error}</div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div><label className="text-sm font-medium text-gray-700 block mb-1">{t.auth.newPassword}</label><div className="relative"><Lock className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" /><input type="password" value={passwords.newPassword} onChange={(e) => setPasswords({...passwords, newPassword: e.target.value})} required className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500" /></div><p className="text-xs text-gray-500 mt-1">{t.auth.passwordRequirements}</p></div>
          <div><label className="text-sm font-medium text-gray-700 block mb-1">{t.auth.confirmPassword}</label><div className="relative"><Lock className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" /><input type="password" value={passwords.confirmPassword} onChange={(e) => setPasswords({...passwords, confirmPassword: e.target.value})} required className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500" /></div></div>
          <button type="submit" disabled={loading} className="w-full bg-pink-600 text-white py-2.5 rounded-lg font-semibold hover:bg-pink-700 transition-colors shadow-md flex justify-center items-center">{loading ? <Loader className="animate-spin h-5 w-5" /> : t.auth.resetTitle}</button>
        </form>
      </div>
    </div>
  );
}
